// @flow
import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { List } from 'immutable';
import type { TEmployee } from '../../reducers/employeesReducer';
import { bindActionCreators } from 'redux';

import EmployeeEdit from './EmployeeEdit';
import EmployeeOverview from './EmployeeOverview';
import { fetchEmployees, setCrumbPath, editEmployee } from '../../actions';
import ExternOverview from './EmployeeOverview/ExternOverview';

type Props = {
    match: any,
    employees: List<TEmployee>,
    employee: TEmployee,
    editEmployee: (employee: TEmployee) => void,
    setEditEmployee: (employee: TEmployee) => void,
    display: string,
    vv_functions: boolean,
};

type State = {
    detailDialogOpen: boolean,
};

const mapStateToProps = (store, props) => {
    const loading = store.entities.employees.isFetching;
    const employees = store.entities.employees;
    const employee = store.drafts.employees.editemployee;

    return {
        loading: loading,
        employees: employees.allIds.map((id) => employees.byId[id]),
        employeesById: employees.byId,
        employee: employee,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetchEmployees: () => {
            dispatch(fetchEmployees(ownProps.display));
        },
        editEmployee: (id) => {
            dispatch(push('/medewerkers/' + id));
        },
        setCrumbPath: () => {
            dispatch(setCrumbPath({ title: 'Medewerkers' }));
        },
        setEditEmployee: bindActionCreators(editEmployee, dispatch),
    };
};

class Employee extends React.Component<Props, State> {
    props: Props;
    state: State = {
        detailDialogOpen: false,
    };

    handleRequestClose = (event) => {
        this.setState({ detailDialogOpen: false });
    };

    componentWillMount() {
        this.props.fetchEmployees();
        this.props.setCrumbPath();
    }

    componentDidMount() {
        this.processProps(this.props);
    }

    componentWillReceiveProps(newProps: Props) {
        this.processProps(newProps);
    }

    processProps = (props: Props) => {
        const paramId = props.params.id
            ? parseInt(props.params.id, 10)
            : undefined;

        if (!props.employee || props.employee.id !== paramId) {
            if (props.employeesById) {
                props.setEditEmployee(props.employeesById[paramId]);
            }
        }
    };

    render() {
        const showDetailDialog = this.props.params.id !== undefined;
        const { employees, employee, vv_functions } = this.props;

        return (
            <div>
                {this.props.display === 'employee' ? (
                    <EmployeeOverview
                        employees={employees}
                        startEditEmployee={this.props.editEmployee}
                        display={this.props.display}
                    />
                ) : (
                    <ExternOverview
                        employees={employees}
                        startEditEmployee={this.props.editEmployee}
                        display={this.props.display}
                        vv_functions={vv_functions}
                    />
                )}
                <EmployeeEdit
                    open={showDetailDialog}
                    editemployee={employee}
                    display={this.props.display}
                />
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Employee);
